<template>
    <div>
        <div class="inner">
            <el-row class="onlyMobile">
                <el-col>
                    <h3>FAQ</h3>
                </el-col>
            </el-row>
            <div class="chooseBoxes">
                <router-link :to="{ path: ROUTING.autopaySdk.faq.android }">
                    <p class="withAndroidIcon">Android</p>
                </router-link>
                <router-link :to="{ path: ROUTING.autopaySdk.faq.ios }">
                    <p class="withIosIcon">IOS</p>
                </router-link>
            </div>
        </div>
    </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex'
import { ROUTING } from '../../../const/routing.const'

export default {
  name: 'AutopaySdkFaqView',
  data () {
    return {
      loading: true,
      ROUTING: ROUTING
    }
  },
  methods: {
    ...mapMutations([
      'setSdkCurrentDevice'
    ])
  },
  watch: {
    device: function (value) {
      if (value && value !== this.selectedDevice) {
        this.$router.push(ROUTING.autopaySdk.faq[value])
      }
    }
  },
  computed: {
    ...mapState({
      device: state => state.sdk.device
    })
  },
  created () {
    this.setSdkCurrentDevice('')
  }
}
</script>
